import configJson from './svcMessage.json';
export const SVCMessage = configJson["SVCMessage"];


// WEBPACK FOOTER //
// ./src/_helpers/svcMessage.js